import React, { useMemo } from 'react';
import { BrandColor } from '@styleseat/brand';
import { SetUpMyBusinessLinkProps } from './types';
import { Button } from '../../ui';

const BASE_SET_UP_BUSINESS_STYLES = {
  color: BrandColor.FloraDark,
  margin: 'auto',
  fontWeight: 700,
  background: BrandColor.WhiteWash,
  whitSpace: 'nowrap',
  fontFamily: '',
  fontSize: 18,
};

export const SetUpMyBusinessLink = ({
  onSetUpMyBusinessClicked = () => {},
  testID,
  breakpoints,
  shouldUseButtonStyle = false,
}: SetUpMyBusinessLinkProps) => {
  const setupMyBusinessText = (breakpoints.desktop && !breakpoints.wide) ? 'Set Up My\nBusiness' : 'Set Up My Business';

  const isMobileOrMobileLayout = useMemo(() => (
    breakpoints.mobile
    || breakpoints.mobileLayout
    || breakpoints.tablet
    || breakpoints.desktopNarrow
  ), [breakpoints]);

  const setUpMyBusinessStyle = useMemo(() => {
    if (!shouldUseButtonStyle) return BASE_SET_UP_BUSINESS_STYLES;

    return {
      background: BrandColor.Green,
      color: BrandColor.WhiteWash,

      paddingTop: isMobileOrMobileLayout ? 0 : undefined,
      paddingBottom: isMobileOrMobileLayout ? 0 : undefined,
      paddingLeft: isMobileOrMobileLayout ? 6 : undefined, // Special case to avoid text wrapping
      paddingRight: isMobileOrMobileLayout ? 6 : undefined, // Special case to avoid text wrapping
    };
  }, [
    isMobileOrMobileLayout,
    shouldUseButtonStyle,
  ]);

  const buttonSize = useMemo(() => (
    shouldUseButtonStyle && isMobileOrMobileLayout ? 'small' : 'medium'
  ), [
    shouldUseButtonStyle,
    isMobileOrMobileLayout,
  ]);

  return (
    <Button
      testID={testID}
      style={setUpMyBusinessStyle}
      size={buttonSize}
      onClick={onSetUpMyBusinessClicked}
    >
      {setupMyBusinessText}
    </Button>
  );
};
